import { Box, Container, Typography } from "@mui/material";
import { useState } from "react";
import { useSpring, animated } from "react-spring";

import car_imgUrl from "@/assets/images/about-us/map.png";
import car_thumbnail_imgUrl from "@/assets/images/about-us/map_thumbnail.png";
import useResponsive from "@/hooks/useResponsive";
import { imageContainerStyles } from "./styles";

const About = () => {
  const isDesktop = useResponsive("up", "lg");

  const [imageLoaded, setImageLoaded] = useState(false); // Image loading state

  // Handle image loading
  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const fadeInProps = useSpring({
    opacity: imageLoaded ? 1 : 0,
    from: { opacity: 0 },
    config: { duration: 300 },
  });

  const fadeInThumbProps = useSpring({
    opacity: imageLoaded ? 0 : 1, // Hide thumbnail when full image is loaded
    filter: `blur(10px)`,
    from: { opacity: 1 },
    config: { duration: 300 },
  });

  return (
    <Box
      component="section"
      pt={{ xs: 0, md: 2, lg: 16.5 }}
      pb={{ xs: 5, md: 6, lg: 18 }}
      sx={{ overflow: "hidden" }}
    >
      <Container sx={{ position: "relative", zIndex: 10 }}>
        <Box
          maxWidth={{ xs: "auto", lg: "62%", xl: 840 }}
          minHeight={{ xs: "auto", lg: 220 }}
        >
          <Typography color="text.primary" variant="h1" mb={{ xs: 2, md: 3 }}>
            The story of{" "}
            <Typography variant="h1" color="text.accent" component="span">
              Trackmate
            </Typography>
          </Typography>
          <Typography variant="subtitle1" component="p" color="text.secondary">
            At Trackmate, our journey began with a simple yet powerful vision: to redefine the way people navigate and manage their world. Inspired by the possibilities that cutting-edge technology brings, we embarked on a mission to create intelligent and user-centric GPS tracking solutions.
          </Typography>
        </Box>

        {/* Car Image */}
        {isDesktop && (
          <Box
            position="absolute"
            sx={{
              ...imageContainerStyles,
              img: { width: "100%", height: "auto" },
            }}
          >
            <animated.img
              src={car_thumbnail_imgUrl}
              alt={`moving car preview`}
              style={{
                ...fadeInThumbProps,
                position: "relative",
                zIndex: -2,
                transition: "opacity 0.3s ease",
              }}
            />
            <animated.img
              src={car_imgUrl}
              alt="moving car"
              style={{
                ...fadeInProps,
                position: "absolute",
                zIndex: -1,
                top: 0,
                left: 0,
                transition: "opacity 0.3s ease",
              }}
              onLoad={handleImageLoad}
            />
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default About;
